import { NavLink } from "react-router-dom";
import Logo from "../../UI/Logo/Logo";
import { LOGO_THEME } from "../../../constants/logo";
import LoginForm from "../LoginForm/LoginForm";
import { BsArrowLeftShort } from "react-icons/bs";

const FormContainer = () => {
  return (
    <>
      <div className="absolute left-10 top-10 flex lg:hidden items-center">
        <Logo theme={LOGO_THEME.DARK} />
      </div>
      <div className="text-right relative top-28 w-11/12 mx-auto md:w-1/2 lg:w-1/4 lg:absolute lg:right-44">
        <button className="text-light-black font-bold border border-light-gray rounded-lg mb-10">
          <NavLink to="/" className="p-4 flex items-center gap-2.5 text-2xl">
            العودة الي الرئيسية
            <BsArrowLeftShort size={24} />
          </NavLink>
        </button>
        <h1 className="mb-5 text-2xl">تسجيل الدخول</h1>
        <LoginForm />
      </div>
    </>
  );
};

export default FormContainer;
